export const AI_ASSISTANT_ROUTES = {
	chat: "/app/ai",
} as const;
